// src/pages/CreateEducationContentPage/components/organisms/OrganismsContentPopup.jsx
import React, { useState } from "react";
import styled, { css } from "styled-components";
import MoleculePopupDropdown from "../molecules/MoleculePopupDropdown";
import MoleculePopupCalender from "../molecules/MoleculePopupCalender";
import MoleculePopupBoard from "../molecules/MoleculePopupBoard";
import MoleculePopupColor from "../molecules/MoleculePopupColor";
import { updateEduTimetableOnServer } from "../../../../utils/indexedDB";
import { OPTIONS as PeriodOptions } from "../molecules/MoleculePopupDropdown";

/**
 * @component OrganismsContentPopup
 * @description 팝업 형태의 콘텐츠 편성 컴포넌트
 */

export default function OrganismsContentPopup({ onClose, contentList = [] }) {
  const [mode, setMode] = useState("daily");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const [calendarOpen, setCalendarOpen] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);
  const [showStartPeriodDropdown, setShowStartPeriodDropdown] = useState(false);
  const [showEndPeriodDropdown, setShowEndPeriodDropdown] = useState(false);
  const [isRepeatDaily, setIsRepeatDaily] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState({
    label: "1교시+쉬는시간",
    time: "",
  });
  const [selectedStartPeriod, setSelectedStartPeriod] = useState({
    label: "1교시+쉬는시간",
    time: "",
  });
  const [selectedEndPeriod, setSelectedEndPeriod] = useState({
    label: "1교시+쉬는시간",
    time: "",
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  // 콘텐츠 선택 관련 상태들
  const [showContentDropdown, setShowContentDropdown] = useState(false);
  const [selectedContent, setSelectedContent] = useState([]);
  const [isContentSelected, setIsContentSelected] = useState(false);

  // 색상 선택 관련 상태들
  const [showColorDropdown, setShowColorDropdown] = useState(false);
  const [selectedColor, setSelectedColor] = useState({
    bg: "#ECF2FE",
    border: "#88B0FF",
  });
  const [isColorSelected, setIsColorSelected] = useState(false);

  // 선택된 상태를 관리하는 state들
  const [isDateSelected, setIsDateSelected] = useState(false);
  const [isStartDateSelected, setIsStartDateSelected] = useState(false);
  const [isEndDateSelected, setIsEndDateSelected] = useState(false);
  const [isPeriodSelected, setIsPeriodSelected] = useState(false);
  const [isStartPeriodSelected, setIsStartPeriodSelected] = useState(false);
  const [isEndPeriodSelected, setIsEndPeriodSelected] = useState(false);

  const handleConfirm = async () => {
    try {
      const eduTimetableDetailString =
        sessionStorage.getItem("eduTimetableDetail");
      if (!eduTimetableDetailString) {
        console.error("eduTimetableDetail not found in sessionStorage");
        return;
      }
      const eduTimetableDetail = JSON.parse(eduTimetableDetailString);

      const newContentData = {
        contentId: selectedContent[0]?._id,
        contentTitle: getContentDisplayText(),
      };

      if (mode === "daily") {
        // 일일 설정 로직
        const selectedDay = selectedDate.getDate().toString().padStart(2, "0");
        const dayKey = `day-${selectedDay}`;

        let periodKey = "";
        const periodLabel = selectedPeriod.label;
        if (periodLabel.includes("교시")) {
          periodKey = `class${periodLabel.charAt(0)}`;
        } else {
          switch (periodLabel) {
            case "아침조례":
              periodKey = "morning";
              break;
            case "점심시간":
              periodKey = "lunch";
              break;
            case "종례 시간":
              periodKey = "after-class";
              break;
            case "동아리활동":
              periodKey = "club";
              break;
            default:
              periodKey = "unknown";
          }
        }

        if (!eduTimetableDetail.dailyContents[dayKey]) {
          eduTimetableDetail.dailyContents[dayKey] = {};
        }
        eduTimetableDetail.dailyContents[dayKey][periodKey] = newContentData;
      } else {
        // 기간 설정 로직
        const start = new Date(startDate);
        const end = new Date(endDate);
        const startIndex = PeriodOptions.findIndex(
          (p) => p.label === selectedStartPeriod.label
        );
        const endIndex = PeriodOptions.findIndex(
          (p) => p.label === selectedEndPeriod.label
        );

        if (startIndex === -1 || endIndex === -1) {
          console.error("Invalid period selection");
          return;
        }

        for (let d = start; d <= end; d.setDate(d.getDate() + 1)) {
          const dayKey = `day-${d.getDate().toString().padStart(2, "0")}`;
          if (!eduTimetableDetail.dailyContents[dayKey]) {
            eduTimetableDetail.dailyContents[dayKey] = {};
          }

          for (let i = startIndex; i <= endIndex; i++) {
            const periodLabel = PeriodOptions[i].label;
            let periodKey = "";
            if (periodLabel.includes("교시")) {
              periodKey = `class${periodLabel.charAt(0)}`;
            } else {
              switch (periodLabel) {
                case "아침조례":
                  periodKey = "morning";
                  break;
                case "점심시간":
                  periodKey = "lunch";
                  break;
                case "종례 시간":
                  periodKey = "after-class";
                  break;
                case "동아리활동":
                  periodKey = "club";
                  break;
                default:
                  periodKey = "unknown";
              }
            }
            eduTimetableDetail.dailyContents[dayKey][periodKey] =
              newContentData;
          }
        }
      }

      sessionStorage.setItem(
        "eduTimetableDetail",
        JSON.stringify(eduTimetableDetail)
      );

      await updateEduTimetableOnServer(eduTimetableDetail.tableId, {
        dailyContents: eduTimetableDetail.dailyContents,
      });

      console.log("Updated Timetable:", eduTimetableDetail);
      onClose();
    } catch (error) {
      console.error("Failed to update timetable:", error);
    }
  };

  const prevMonth = () => {
    setCalendarOpen(
      new Date(calendarOpen.getFullYear(), calendarOpen.getMonth() - 1, 1)
    );
  };
  const nextMonth = () => {
    setCalendarOpen(
      new Date(calendarOpen.getFullYear(), calendarOpen.getMonth() + 1, 1)
    );
  };
  const onDateSelect = (date) => {
    setSelectedDate(date);
    setShowCalendar(false);
  };

  // 요일을 한국어로 반환하는 함수
  const getKoreanDayOfWeek = (date) => {
    const days = [
      "일요일",
      "월요일",
      "화요일",
      "수요일",
      "목요일",
      "금요일",
      "토요일",
    ];
    return days[date.getDay()];
  };

  // 날짜를 포맷팅하는 함수 (요일 포함)
  const formatDateWithDay = (date) => {
    const formattedDate = date.toLocaleDateString("ko-KR").replace(/\./g, "/");
    const dayOfWeek = getKoreanDayOfWeek(date);
    return `${formattedDate} ${dayOfWeek}`;
  };

  // 콘텐츠 선택 확인 함수
  const handleContentConfirm = (selected) => {
    setSelectedContent(selected); // selected는 이제 [{...content}] 형태
    setShowContentDropdown(false);
    setIsContentSelected(selected.length > 0);
  };

  // 색상 선택 확인 함수
  const handleColorConfirm = (color) => {
    setSelectedColor(color);
    setShowColorDropdown(false);
    setIsColorSelected(true);
  };

  // 선택된 콘텐츠 표시 텍스트
  const getContentDisplayText = () => {
    if (selectedContent.length === 0) return "선택하세요";
    const content = selectedContent[0];
    return (
      content?.dataAnalysis?.title ||
      content?.contentTitle ||
      `콘텐츠 ${content?._id}`
    );
  };

  return (
    <>
      {/* 클릭 시 팝업 닫기 */}
      <Overlay onClick={onClose} />
      <PopupContainer>
        <Header>
          <Heading>콘텐츠 활성화 설정</Heading>
          {/* X 버튼 누르면 onClose 호출 */}
          <IconButton onClick={onClose}>
            <CloseSvg />
          </IconButton>
        </Header>

        <AllSection>
          <Section>
            <Row>
              <FieldGroup>
                <Label>콘텐츠 불러오기</Label>
                <DropdownWrapper>
                  <SelectBox onClick={() => setShowContentDropdown((s) => !s)}>
                    <SelectText isSelected={isContentSelected}>
                      {getContentDisplayText()}
                    </SelectText>
                    <ChevronIcon>
                      <ChevronSvg isOpen={showContentDropdown} />
                    </ChevronIcon>
                  </SelectBox>
                  {showContentDropdown && (
                    <DropdownContainer>
                      <MoleculePopupBoard
                        onConfirm={handleContentConfirm}
                        contentList={contentList}
                      />
                    </DropdownContainer>
                  )}
                </DropdownWrapper>
              </FieldGroup>
              <FieldGroup>
                <Label>컬러</Label>
                <DropdownWrapper>
                  <SelectColorBox
                    onClick={() => setShowColorDropdown((s) => !s)}
                  >
                    <ColorRectangle color={selectedColor.bg} />
                    <ChevronIcon>
                      <ChevronSvg isOpen={showColorDropdown} />
                    </ChevronIcon>
                  </SelectColorBox>
                  {showColorDropdown && (
                    <DropdownContainer>
                      <MoleculePopupColor onConfirm={handleColorConfirm} />
                    </DropdownContainer>
                  )}
                </DropdownWrapper>
              </FieldGroup>
            </Row>

            <Tabs>
              <Label>편성 일시 설정</Label>
              <TabBox>
                <TabItem onClick={() => setMode("daily")}>
                  <TabCircle active={mode === "daily"} />
                  <TabLabel>일일 설정</TabLabel>
                </TabItem>
                <TabItem onClick={() => setMode("period")}>
                  <TabCircle active={mode === "period"} />
                  <TabLabel>기간 설정</TabLabel>
                </TabItem>
              </TabBox>
            </Tabs>

            <DateTimeSection>
              {mode === "daily" ? (
                <>
                  <OneLine>
                    {/* 달력 드롭다운 */}
                    <DropdownWrapper>
                      <DateBox onClick={() => setShowCalendar((s) => !s)}>
                        <DateText isSelected={isDateSelected}>
                          {formatDateWithDay(selectedDate)}
                        </DateText>
                        <CalendarIcon>
                          <CalendarSvg />
                        </CalendarIcon>
                      </DateBox>
                      {showCalendar && (
                        <DropdownContainer>
                          <MoleculePopupCalender
                            month={calendarOpen}
                            onPrevMonth={prevMonth}
                            onNextMonth={nextMonth}
                            selectedDate={selectedDate}
                            onSelectDate={setSelectedDate}
                            onConfirm={() => {
                              setShowCalendar(false);
                              setIsDateSelected(true);
                            }}
                            width={305}
                          />
                        </DropdownContainer>
                      )}
                    </DropdownWrapper>

                    {/* 교시 드롭다운 */}
                    <DropdownWrapper>
                      <PeriodBox
                        onClick={() => setShowPeriodDropdown((s) => !s)}
                      >
                        <PeriodText isSelected={isPeriodSelected}>
                          {selectedPeriod.label}
                        </PeriodText>
                        <PeriodIcon>
                          <ChevronSvg isOpen={showPeriodDropdown} />
                        </PeriodIcon>
                      </PeriodBox>
                      {showPeriodDropdown && (
                        <DropdownContainer>
                          <MoleculePopupDropdown
                            oneSelect={setSelectedPeriod}
                            currentSelected={selectedPeriod}
                            onConfirm={() => {
                              setShowPeriodDropdown(false);
                              setIsPeriodSelected(true);
                            }}
                          />
                        </DropdownContainer>
                      )}
                    </DropdownWrapper>
                  </OneLine>

                  <SideLine>
                    <StyledFrame
                      onClick={() => setIsRepeatDaily((prev) => !prev)}
                      on={isRepeatDaily}
                    >
                      <StyledEllipse on={isRepeatDaily} />
                    </StyledFrame>
                    <Label>매일 반복하기</Label>
                  </SideLine>
                </>
              ) : (
                <TwoLine>
                  {/* 시작일 */}
                  <OneLine>
                    <Labe2>시작일</Labe2>
                    <DropdownWrapper>
                      <DateBox2 onClick={() => setShowStartCalendar((s) => !s)}>
                        <DateText isSelected={isStartDateSelected}>
                          {formatDateWithDay(startDate)}
                        </DateText>
                        <CalendarIcon>
                          <CalendarSvg />
                        </CalendarIcon>
                      </DateBox2>
                      {showStartCalendar && (
                        <DropdownContainer>
                          <MoleculePopupCalender
                            month={calendarOpen}
                            onPrevMonth={prevMonth}
                            onNextMonth={nextMonth}
                            selectedDate={startDate}
                            onSelectDate={setStartDate}
                            onConfirm={() => {
                              setShowStartCalendar(false);
                              setIsStartDateSelected(true);
                            }}
                            width={240}
                          />
                        </DropdownContainer>
                      )}
                    </DropdownWrapper>
                    <DropdownWrapper>
                      <PeriodBox
                        onClick={() => setShowStartPeriodDropdown((s) => !s)}
                      >
                        <PeriodText isSelected={isStartPeriodSelected}>
                          {selectedStartPeriod.label}
                        </PeriodText>
                        <PeriodIcon>
                          <ChevronSvg isOpen={showStartPeriodDropdown} />
                        </PeriodIcon>
                      </PeriodBox>
                      {showStartPeriodDropdown && (
                        <DropdownContainer>
                          <MoleculePopupDropdown
                            oneSelect={setSelectedStartPeriod}
                            currentSelected={selectedStartPeriod}
                            onConfirm={() => {
                              setShowStartPeriodDropdown(false);
                              setIsStartPeriodSelected(true);
                            }}
                          />
                        </DropdownContainer>
                      )}
                    </DropdownWrapper>
                  </OneLine>

                  {/* 종료일 */}
                  <OneLine>
                    <Labe2>종료일</Labe2>
                    <DropdownWrapper>
                      <DateBox2 onClick={() => setShowEndCalendar((s) => !s)}>
                        <DateText isSelected={isEndDateSelected}>
                          {formatDateWithDay(endDate)}
                        </DateText>
                        <CalendarIcon>
                          <CalendarSvg />
                        </CalendarIcon>
                      </DateBox2>
                      {showEndCalendar && (
                        <DropdownContainer>
                          <MoleculePopupCalender
                            month={calendarOpen}
                            onPrevMonth={prevMonth}
                            onNextMonth={nextMonth}
                            selectedDate={endDate}
                            onSelectDate={setEndDate}
                            onConfirm={() => {
                              setShowEndCalendar(false);
                              setIsEndDateSelected(true);
                            }}
                            width={240}
                          />
                        </DropdownContainer>
                      )}
                    </DropdownWrapper>
                    <DropdownWrapper>
                      <PeriodBox
                        onClick={() => setShowEndPeriodDropdown((s) => !s)}
                      >
                        <PeriodText isSelected={isEndPeriodSelected}>
                          {selectedEndPeriod.label}
                        </PeriodText>
                        <PeriodIcon>
                          <ChevronSvg isOpen={showEndPeriodDropdown} />
                        </PeriodIcon>
                      </PeriodBox>
                      {showEndPeriodDropdown && (
                        <DropdownContainer>
                          <MoleculePopupDropdown
                            oneSelect={setSelectedEndPeriod}
                            currentSelected={selectedEndPeriod}
                            onConfirm={() => {
                              setShowEndPeriodDropdown(false);
                              setIsEndPeriodSelected(true);
                            }}
                          />
                        </DropdownContainer>
                      )}
                    </DropdownWrapper>
                  </OneLine>
                </TwoLine>
              )}
            </DateTimeSection>
          </Section>
        </AllSection>

        <Footer>
          <ConfirmButton onClick={handleConfirm}>
            <ConfirmText>완료</ConfirmText>
          </ConfirmButton>
        </Footer>
      </PopupContainer>
    </>
  );
}

const PopupContainer = styled.div`
  width: 720px;
  padding: 40px;
  background: white;
  border-radius: 20px;
  outline: 1px solid #e0e4eb;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Heading = styled.span`
  color: #131416;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
`;

const IconButton = styled.button`
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

// 닫기 버튼용 X 아이콘 SVG
const CloseSvg = ({ fill = "#33363D", width = 24, height = 24, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
      fill={fill}
    />
  </svg>
);

const AllSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
`;

const Label = styled.span`
  color: #464c53;
  font-size: 16px;
  font-weight: 400;
  line-height: 28.5px;
`;

const Labe2 = styled.span`
  width: 45px;
  color: #464c53;
  font-size: 17px;
  font-weight: 400;
  line-height: 28.5px;
`;

const SelectBox = styled.div`
  height: 56px;
  width: 544px;
  padding: 0 16px;
  border-radius: 8px;
  outline: 1px rgba(179, 183, 186, 0.5) solid;
  outline-offset: -1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const SelectColorBox = styled.div`
  width: 88px;
  height: 56px;
  padding: 0 16px;
  border-radius: 8px;
  outline: 1px rgba(179, 183, 186, 0.5) solid;
  outline-offset: -1px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

const ColorRectangle = styled.div`
  width: 24.54px;
  height: 24.54px;
  background: ${(props) => props.color};
  border-radius: 4px;
  flex-shrink: 0;
`;

const SelectText = styled.span`
  color: ${(props) => (props.isSelected ? "#131416" : "#464C53")};
  font-size: 19px;
  font-weight: 400;
  line-height: 28.5px;
`;

const ChevronIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const Tabs = styled.div`
  display: flex;
  align-items: center;
  gap: 326px;
  margin-bottom: -24px;
`;

const TabBox = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const TabItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const TabCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  border: ${(props) =>
    props.active ? "4px solid #256EF4" : "1px solid #E5E5EA"};
`;

const TabLabel = styled.span`
  color: #464c53;
  font-size: 19px;
  font-weight: 400;
  line-height: 28.5px;
`;

const DateTimeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const OneLine = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const TwoLine = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SideLine = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const DateBox = styled(SelectBox)`
  width: 305px;
`;

const DateBox2 = styled(SelectBox)`
  width: 240px;
`;

const DateText = styled.span`
  color: ${(props) => (props.isSelected ? "#131416" : "#8A949E")};
  font-size: 19px;
  font-weight: 400;
  line-height: 28.5px;
`;

const CalendarIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;

const CalendarSvg = ({
  fill = "#74798B",
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1652 1.66621C14.1652 1.20712 13.793 0.834961 13.3339 0.834961C12.8748 0.834961 12.5027 1.20712 12.5027 1.66621V2.50183H7.4977V1.66621C7.4977 1.20712 7.12554 0.834961 6.66646 0.834961C6.20737 0.834961 5.83521 1.20712 5.83521 1.66621V2.50183H4.16686C2.7873 2.50183 1.66895 3.62019 1.66895 4.99975V8.33308V16.6664C1.66895 18.046 2.7873 19.1643 4.16686 19.1643H15.8335C17.2131 19.1643 18.3314 18.046 18.3314 16.6664V8.33308V4.99975C18.3314 3.62019 17.2131 2.50183 15.8335 2.50183H14.1652V1.66621ZM16.6689 7.50183V4.99975C16.6689 4.53836 16.2949 4.16433 15.8335 4.16433H14.1652V4.99954C14.1652 5.45863 13.793 5.83079 13.3339 5.83079C12.8748 5.83079 12.5027 5.45863 12.5027 4.99954V4.16433H7.4977V4.99954C7.4977 5.45863 7.12554 5.83079 6.66646 5.83079C6.20737 5.83079 5.83521 5.45863 5.83521 4.99954V4.16433H4.16686C3.70547 4.16433 3.33145 4.53836 3.33145 4.99975V7.50183H16.6689ZM3.33145 9.16433H16.6689V16.6664C16.6689 17.1278 16.2949 17.5018 15.8335 17.5018H4.16686C3.70547 17.5018 3.33145 17.1278 3.33145 16.6664V9.16433Z"
      fill={fill}
    />
  </svg>
);

const PeriodBox = styled(SelectBox)`
  width: 315px;
`;

const PeriodText = styled.span`
  color: ${(props) => (props.isSelected ? "#131416" : "#8A949E")};
  font-size: 19px;
  font-weight: 400;
  line-height: 28.5px;
`;

const PeriodIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const ChevronSvg = ({
  isOpen = false,
  fill = "#33363D",
  width = 24,
  height = 24,
  ...props
}) =>
  isOpen ? (
    // 위쪽 화살표 (드롭다운 열림)
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.26563 15.5949C3.93721 15.2994 3.91056 14.7936 4.20611 14.4651L11.4053 6.46515C11.557 6.29656 11.7732 6.20029 12 6.20029C12.2268 6.20028 12.4429 6.29654 12.5946 6.46511L19.7946 14.4651C20.0902 14.7935 20.0636 15.2994 19.7352 15.5949C19.4068 15.8905 18.9009 15.8639 18.6054 15.5355L12 8.1962L5.39544 15.5354C5.09989 15.8638 4.59406 15.8905 4.26563 15.5949Z"
        fill={fill}
      />
    </svg>
  ) : (
    // 아래쪽 화살표 (드롭다운 닫힘)
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7344 8.40505C20.0628 8.7006 20.0894 9.20643 19.7939 9.53485L12.5947 17.5349C12.443 17.7034 12.2268 17.7997 12 17.7997C11.7732 17.7997 11.5571 17.7035 11.4054 17.5349L4.20537 9.53489C3.9098 9.20648 3.93643 8.70065 4.26484 8.40508C4.59324 8.10951 5.09908 8.13613 5.39464 8.46454L12 15.8038L18.6046 8.46457C18.9001 8.13615 19.4059 8.1095 19.7344 8.40505Z"
        fill={fill}
      />
    </svg>
  );

const Footer = styled.div`
  display: flex;
  justify-content: center;
`;

const ConfirmButton = styled.button`
  width: 100%;
  max-width: 640px;
  height: 48px;
  background: #256ef4;
  border: none;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConfirmText = styled.span`
  color: white;
  font-size: 17px;
  font-weight: 400;
  line-height: 25.5px;
`;

// 드롭다운 감싸는 wrapper
const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

// 드롭다운 박스 위치
const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 1000;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  z-index: 999;
`;

const StyledFrame = styled.div`
  width: 48px; /* 원하는 토글 전체 폭 */
  height: 24px; /* 높이 */
  padding: 4px;
  background: ${(props) => (props.on ? "#256EF4" : "#E8E8E8")};
  border-radius: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StyledEllipse = styled.div`
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 9999px;
  transition: transform 0.2s ease;

  ${({ on }) =>
    on
      ? css`
          transform: translateX(24px);
        ` // 토글 오른쪽 위치
      : css`
          transform: translateX(0);
        `}// 토글 왼쪽 위치
`;
